import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, inject } from 'vue';
import { useFieldArray } from 'vee-validate';
import OcrTaxLineRow from 'vcomponents/ocr/OcrTaxLineRow.vue';
import type { OcrTaxLine } from 'composables/ocr/types';
import type { TaxRate } from 'types/entities/accounting/taxRate.type';
import type { AccountingCode } from 'types/entities/accounting/accountingCode.type';
import type { Unit } from 'types/entities/units/unit.type';
import type { Translator } from 'types/injects/translator.type';

interface Props {
    taxRates: TaxRate[];
    accountingCodes: AccountingCode[];
    units?: Unit[];
    showAnalyticCode?: boolean;
    currencySymbol?: string;
    disabled?: boolean;
    isElectronic?: boolean;
    addTaxLine: () => void;
    requestTaxLineDelete: (index: number) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OcrTaxLinesTable',
  props: {
    taxRates: {},
    accountingCodes: {},
    units: { default: () => [] },
    showAnalyticCode: { type: Boolean, default: false },
    currencySymbol: { default: undefined },
    disabled: { type: Boolean, default: false },
    isElectronic: { type: Boolean, default: false },
    addTaxLine: {},
    requestTaxLineDelete: {}
  },
  setup(__props: any) {

const props = __props;

const $t = inject('$t') as Translator;

const taxLinesArray = useFieldArray<OcrTaxLine>('taxLines');

const canDelete = computed<boolean>(() => taxLinesArray.fields.value.length > 1);

return (_ctx: any,_cache: any) => {
  const _component_CompassTableHeadCell = _resolveComponent("CompassTableHeadCell")!
  const _component_CompassTableHead = _resolveComponent("CompassTableHead")!
  const _component_CompassTableBody = _resolveComponent("CompassTableBody")!
  const _component_CompassTable = _resolveComponent("CompassTable")!
  const _component_CompassButton = _resolveComponent("CompassButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CompassTable, {
      size: _ctx.CompassEnums.TableSize.MEDIUM
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CompassTableHead, null, {
          default: _withCtx(() => [
            _createVNode(_component_CompassTableHeadCell, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t).__('ocr.OcrVerificationForm.tax_rate')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_CompassTableHeadCell, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t).__('ocr.OcrVerificationProductsTable.supplier_product')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_CompassTableHeadCell, { class: "ocr-tax-lines-table__header--align-right" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t).__('common.labels.amount_excluding_tax')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_CompassTableHeadCell, { class: "ocr-tax-lines-table__header--align-right" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t).__('common.labels.amount_including_tax')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_CompassTableHeadCell, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t).__('ocr.OcrVerificationProductsTable.unit_optional')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_CompassTableHeadCell, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t).__('common.labels.accounting_code')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }),
            (props.showAnalyticCode)
              ? (_openBlock(), _createBlock(_component_CompassTableHeadCell, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t).__('ocr.OcrVerificationProductsTable.analytic_code_optional')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_CompassTableHeadCell, {
              id: "delete",
              fixed: "right",
              defaultWidth: 80
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_CompassTableBody, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(taxLinesArray).fields.value, (field, index) => {
              return (_openBlock(), _createBlock(OcrTaxLineRow, {
                key: field.key,
                index: index,
                disabled: props.disabled || props.isElectronic,
                canDelete: canDelete.value,
                taxRates: props.taxRates,
                accountingCodes: props.accountingCodes,
                units: props.units,
                showAnalyticCode: props.showAnalyticCode,
                currencySymbol: props.currencySymbol,
                onRequestDelete: props.requestTaxLineDelete
              }, null, 8 /* PROPS */, ["index", "disabled", "canDelete", "taxRates", "accountingCodes", "units", "showAnalyticCode", "currencySymbol", "onRequestDelete"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["size"]),
    _createVNode(_component_CompassButton, {
      class: "ocr-tax-lines-table__add-line",
      label: _unref($t).__('ocr.OcrVerificationForm.add_line'),
      type: _ctx.CompassEnums.ButtonType.TERTIARY,
      disabled: props.disabled || props.isElectronic,
      leftIcon: "plus",
      onClick: props.addTaxLine
    }, null, 8 /* PROPS */, ["label", "type", "disabled", "onClick"])
  ]))
}
}

})